
jQuery(document).ready(function($) {
    $('[data-open-popup="login-popup"]').on('click', function() {
        $('.login-popup-2').addClass('login-popup-2-active');
    });
    $('[data-close-popup="login-popup"]').on('click', function() {
        $('.login-popup-2').removeClass('login-popup-2-active');
    });


    $(".password-eye").on("click", function() {
        let $passwordInput = $(this).prev("input");
        
        if ($passwordInput.attr("type") === "password") {
            $passwordInput.attr("type", "text");
            $(this).removeClass("password-hidden").addClass("password-visible");
        } else {
            $passwordInput.attr("type", "password");
            $(this).removeClass("password-visible").addClass("password-hidden");
        }
    });

    $("[data-popup-form]").on("click", function() {
        let formType = $(this).attr("data-popup-form");

        if (formType === "login") {
     
            $("#popup-create").addClass("login-popup-2-login-create--active");
            $("#popup-login").removeClass("login-popup-2-login-login--active");
        } else if (formType === "create") {
        
            $("#popup-login").addClass("login-popup-2-login-login--active");
            $("#popup-create").removeClass("login-popup-2-login-create--active");
        }
    });

});